import { Link } from 'react-router-dom'
import type { Menu } from '../../../shared/types/models.js'
import StatusBadge from './StatusBadge.js'

const CARD_CLASS: Record<Menu['status'], string> = {
  ACTIVE: 'menu-card menu-card--active',
  SUSPENDED: 'menu-card menu-card--suspended',
  ARCHIVED: 'menu-card menu-card--archived',
}

export default function MenuCard({ menu, to }: { menu: Menu; to: string }) {
  return (
    <Link to={to} className={CARD_CLASS[menu.status]}>
      <div className="menu-card-top">
        <h3 className="menu-card-name">{menu.name}</h3>
        <StatusBadge status={menu.status} />
      </div>
      {menu.slug && <span className="menu-card-slug">{menu.slug}</span>}
      {menu.description && <p className="menu-card-description">{menu.description}</p>}
    </Link>
  )
}